<ng-container *ngrxLet="vm$ as vm">
    @if (vm) {
        <div class="d-flex align-items-center offers-teaser-tiles">
            @if (offer?.offerContent?.primaryCta?.url) {
                @if (moreInfoCta?.url) {
                    <a
                        ds-button
                        class="w-50"
                        [size]="dsButtonMoreInfoSettings?.size"
                        [variant]="dsButtonMoreInfoSettings?.variant"
                        [kind]="dsButtonMoreInfoSettings?.kind"
                        [attr.href]="moreInfoCta?.url"
                        (click)="navigateToOfferMoreInfo(); $event.preventDefault(); $event.stopPropagation()"
                        target="{{ !!moreInfoCta?.attributes?.target ? moreInfoCta?.attributes?.target : '' }}">
                        {{ moreInfoCta?.text }}
                    </a>
                }
                @if (isSpecialOfferOptIn) {
                    <a
                        class="w-50 ml-2 justify-content-center"
                        ds-button
                        [size]="dsButtonConfig?.dsButton?.size"
                        [variant]="dsButtonConfig?.dsButton?.variant"
                        [kind]="dsButtonConfig?.dsButton?.kind"
                        data-offer-id
                        data-tracking-event="Event.Tracking"
                        [attr.data-tracking-keys]="data_tracking_keys"
                        [attr.data-tracking-values]="data_tracking_Values"
                        [attr.data-offer-id]="Special_offer_Id"
                        [attr.data-offer-type]="Special_offer_Type"
                        [attr.data-offer-message-error]="
                            offerContentConfiguration?.isBetMgmTileRedesignEnabled ? vm?.optedInErrorMessage : vm?.optInInvalidMessage
                        "
                        [attr.data-offer-message-expired]="vm?.optInExpiredMessage"
                        [attr.data-offer-message-invalid]="vm?.optInInvalidMessage"
                        [attr.data-offer-message-not-offered]="vm?.optInUserNotEligibleMessage"
                        [attr.data-offer-message-offered]="vm?.optInMessage"
                        [attr.data-offer-message-opted-in]="vm?.optedInMessage"
                        [attr.data-offer-message-opted-out]=""
                        (click)="specialOffer_Click($event); $event?.stopPropagation(); $event.preventDefault()"
                        id="{{ offerContentConfiguration?.isBetMgmTileRedesignEnabled ? 'BetmgmTileRedesign' : 'NonBetmgmTileRedesign' }}">
                        {{ offer?.offerContent?.primaryCta?.text }}
                    </a>
                }
                @if (!isSpecialOfferOptIn) {
                    <a
                        [ngClass]="{ 'ml-2': moreInfoCta?.url }"
                        class="moreInfo"
                        ds-button
                        [size]="dsButtonPrimaryCtaSettings?.size"
                        [variant]="dsButtonPrimaryCtaSettings?.variant"
                        [kind]="dsButtonPrimaryCtaSettings?.kind"
                        (click)="onPrimaryCtaClick(offer?.offerContent?.primaryCta); $event?.stopPropagation(); $event.preventDefault()"
                        [attr.href]="offer?.offerContent?.primaryCta?.url"
                        target="{{
                            !!offer?.offerContent?.primaryCta?.attributes?.target ? offer?.offerContent?.primaryCta?.attributes?.target : ''
                        }}">
                        {{ offer?.offerContent?.primaryCta?.text }}
                    </a>
                }
            } @else {
                @if (moreInfoCta?.url) {
                    <a
                        [attr.href]="moreInfoCta?.url"
                        ds-button
                        class="moreInfo"
                        [size]="dsButtonMoreInfoSettings?.size"
                        [variant]="dsButtonMoreInfoSettings?.variant"
                        [kind]="dsButtonMoreInfoSettings?.kind"
                        (click)="navigateToOfferMoreInfo(); $event.preventDefault(); $event.stopPropagation()"
                        target="{{ !!moreInfoCta?.attributes?.target ? moreInfoCta?.attributes?.target : '' }}">
                        {{ moreInfoCta?.text }}
                    </a>
                }
            }
        </div>
    }
</ng-container>
